import { render } from "./PR44-08122024.vue?vue&type=template&id=6c6dc530"
import script from "./PR44-08122024.vue?vue&type=script&lang=js"
export * from "./PR44-08122024.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__